import React from "react";
import { ErrorContent, StyledContent } from "./index.styles";

export declare namespace Content {
  type Props = Record<string, unknown>;
  type State = { error: Error | null };
}

export class Content extends React.PureComponent<
  React.PropsWithChildren<Content.Props>,
  Content.State
> {
  static getDerivedStateFromError(error: Error): Content.State {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  state: Content.State = {
    error: null,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render(): React.ReactNode {
    if (this.state.error) {
      // You can render any custom fallback UI

      const stack = this.state.error.stack?.split("\n") ?? [
        this.state.error.message,
      ];
      return (
        <ErrorContent>
          <div className="main-content">
            <h1>Oops!</h1>
            <h2>{stack.splice(0, 1)[0]}</h2>
          </div>
        </ErrorContent>
      );
    }

    return <StyledContent>{this.props.children}</StyledContent>;
  }
}
